import { STORAGE_KEYS } from "../config/storage-keys";
import type { Locale } from "../config/langs";
import { I18N } from "./dict";

export { I18N };
export { TAG_I18N, translateTag } from "./tag-i18n";

// Active locale, read once at module load. Callers mutate it via
// `setLocale()` so there's a single source of truth.
export function currentLocale(): Locale {
  const l = (localStorage.getItem(STORAGE_KEYS.LOCALE) || "fr") as Locale;
  return I18N[l] ? l : "fr";
}

// Persist-only: the router-level side effects (card re-pick, DOM refresh)
// are wired from state/ui layers so this module stays side-effect free
// beyond localStorage.
export function persistLocale(loc: Locale): boolean {
  if (!I18N[loc]) return false;
  localStorage.setItem(STORAGE_KEYS.LOCALE, loc);
  return true;
}

// t("key", ...args) — looks up the active locale's dict, falls back to
// French, and finally to the raw key so missing entries are visible
// rather than silent.
export function t(key: string, ...args: unknown[]): string {
  const dict = I18N[currentLocale()] || I18N.fr;
  const v = dict[key];
  if (typeof v === "function") return v(...args);
  return v != null ? v : key;
}
